import type {
  VolumeDiscountsListResponseType,
  VolumeDiscountsListParametersType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useVolumeDiscountsList = <
  TData = VolumeDiscountsListResponseType,
>(
  params: VolumeDiscountsListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [business?.id, ServerStateKeys.VolumeDiscounts, params],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `volume-discounts`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
